import {
    TypeValues,
    UserVoiceFeedbackTags,
    Team1,
} from 'owa-uservoice/lib/services/UserVoiceFeedbackTags';
import { UserVoiceSearchTeam } from '../components/UserVoiceSearchTeam';

export default function getSearchFeedbackCustomTags(
    userVoiceFeedbackTeam: UserVoiceSearchTeam
): UserVoiceFeedbackTags {
    let userVoiceFeedbackLocationName = null;
    let userVoiceTeam1 = null;

    switch (userVoiceFeedbackTeam) {
        case UserVoiceSearchTeam.MailSearch:
            userVoiceTeam1 = Team1.Search;
            userVoiceFeedbackLocationName = 'Owa mail React';
            break;
        case UserVoiceSearchTeam.CalendarSearch:
            userVoiceTeam1 = Team1.CalendarSearch;
            userVoiceFeedbackLocationName = 'Owa calendar React';
            break;
    }

    const customTags: UserVoiceFeedbackTags = {
        Type: TypeValues.Negative,
        ['Team 1']: userVoiceTeam1,
        FeedbackLocationName: userVoiceFeedbackLocationName,
    };

    return customTags;
}
